import React from 'react';
import { BodySmSm } from '@constants/text.ts';
import { useLingui } from '@lingui/react/macro';
import isNil from 'lodash/isNil';

import type { UserImportedLearning } from '../../../api/importedLearnings.api.ts';
import { ImportedByEmail, ImportedByWrapper } from './styled.tsx';
import type { FilterOption, ImportedByColumnData, MyImportedLearningRow } from './types.ts';

export const LearningTimeCell: React.FC<{ minutes: number | null }> = ({ minutes }) => {
    const { t } = useLingui();

    if (isNil(minutes) || minutes <= 0) {
        return '-';
    }

    const hours = Math.floor(minutes / 60);
    const restMinutes = minutes % 60;

    if (hours === 0) {
        return t`${restMinutes}m`;
    }

    if (restMinutes === 0) {
        return t`${hours}h`;
    }

    return t`${hours}h ${restMinutes}m`;
};

export const ImportedByCell: React.FC<ImportedByColumnData> = ({ name, email }) => (
    <ImportedByWrapper>
        <BodySmSm>{name}</BodySmSm>
        <ImportedByEmail>{email}</ImportedByEmail>
    </ImportedByWrapper>
);

export const mapUserImportedLearningToRow = (item: UserImportedLearning): MyImportedLearningRow => ({
    key: String(item.id),
    employeeId: item.employeeId,
    sourceSystem: item.sourceSystem,
    sourceUserId: item.sourceUserId,
    type: item.type,
    title: item.title,
    completedDateUTC: item.completedDateUTC,
    sourceRank: item.sourceRank,
    isRequired: item.isRequired,
    completionPercent: item.completionPercent,
    score: item.score,
    learningTimeMinutes: item.learningTimeMinutes,
    importedOnUTC: item.importedOnUTC,
    importedBy: {
        name: item.importedByName,
        email: item.importedByEmail,
    },
});

export const toFilterOptions = (values: string[]): FilterOption[] => values.map((value) => ({ text: value, value }));
